import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import {Field} from 'redux-form';
import {Table, Loader, Icon, Popup, Modal, Input} from 'semantic-ui-react';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import {ordersStatus} from '../../../common/dictionaries/accessories';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {toInteger} from '../../../common/util/fieldsNormalization';
import {DropdownField} from '../../../common/components/form';
import {stopEvent} from '../../../common/util/event';
import {Actions} from '../../../common/actions';

class PartsAssignmentTableItems extends Component {
  constructor(props) {
    super(props);
    this.quantityInput = [];
  }

  checkRequiredField(value) {
    return value ? null : 'Required';
  }

  getPartsOptions() {
    const {partsList} = this.props;
    return partsList.map((item) => {
      return {'value': item.code, 'text': `${item.code} - ${item.partName}`};
    });
  }

  getPartInfo(partCode) {
    const {partsList} = this.props;
    const partInfo = find(partsList, {'code': partCode});
    return partInfo || {};
  }

  updatePartInfo(index, event, partCode) {
    if (!partCode) {
      return;
    }
    const partInfo = this.getPartInfo(partCode);
    this.props.addPartInfo(index, partInfo);
  }

  updateTotalValues({index, quantity, unitPrice}) {
    this.props.updateTotals({index, quantity, unitPrice, 'type': 'part'});
  }

  saveQuantityAndItem(index, element, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    const isValidCheckedQuantity = this.validateQuantity(
      element.quantity,
      element.availableStock
    );
    if (!isValidCheckedQuantity) {
      return;
    }
    this.updateTotalValues({
      index,
      'quantity': element.quantity,
      'unitPrice': null,
    });
    this.saveOrDeleteItem(index, 'add', element);
  }

  validateQuantity(quantity, availableStock) {
    if (!quantity) {
      this.props.addMessageBoxError(
        'Debe ingresar un valor entero en el campo CANTIDAD'
      );
      return false;
    }

    if (!Number.isInteger(quantity)) {
      this.props.addMessageBoxError(
        'Verifique el valor ingresado, no puede ser número decimal'
      );
      return false;
    }

    const checkedQuantityMaxAllowed =
      parseInt(availableStock, 10) - parseInt(quantity, 10);
    if (quantity === 0 || checkedQuantityMaxAllowed < 0) {
      this.props.addMessageBoxError(
        `Verifique el valor ingresado, no puede ser 0 ni mayor a ${availableStock}`
      );
      return false;
    }
    return true;
  }

  saveOrDeleteItem(index, action, item) {
    const {order} = this.props;
    const data = {
      'action': action,
      'partCode': item.partCode,
      'quantity': item.quantity,
      'unitPrice': item.unitPrice,
    };
    this.props.managePartInQualityAssuranceOrder(order, index, data);
  }

  onDeleteClick(index, element) {
    this.saveOrDeleteItem(index, 'delete', element);
  }

  renderItems(fields) {
    const {loadingParts, savingItem, orderStatus} = this.props;

    return fields.map((item, index) => {
      const element = fields.get(index);
      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell className='part-code-column'>
            {element.itemSaved && `${element.partCode} - ${element.partName}`}
            {!element.itemSaved && (
              <Field
                name={`${item}.partCode`}
                options={this.getPartsOptions()}
                component={DropdownField}
                loading={loadingParts}
                onChange={this.updatePartInfo.bind(this, index)}
                placeholder='Parte'
                required={!element.itemSaved}
                disabled={savingItem}
                search
              />
            )}
          </Table.Cell>
          <Table.Cell>{element.availableStock}</Table.Cell>
          <Table.Cell className='qty-column'>
            <Field
              name={`${item}.quantity`}
              type='number'
              component={Input}
              required
              autoComplete='off'
              validate={this.checkRequiredField}
              normalize={toInteger}
              disabled={element.itemSaved || !element.partCode || savingItem}
              min='1'
              step='1'
              max='9999999999'
              onKeyDown={(event) =>
                this.saveQuantityAndItem(index, element, event)
              }
              placeholder='Cant.'
              props={{'className': 'text-align-right'}}
              ref={(input) => {
                this.quantityInput[index] = input;
              }}
              withRef
            />
          </Table.Cell>
          <Table.Cell>
            {'$'}
            {getNumericValue(element.unitPrice || 0, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(element.totalPrice || 0, 2)}
          </Table.Cell>
          {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
            <Table.Cell textAlign='center'>
              {element.itemSaved && (
                <Modal
                  size='mini'
                  trigger={
                    <span className='link'>
                      <Popup
                        trigger={
                          <span>
                            <Icon link name='close' color='red' size='large' />
                          </span>
                        }
                        content='Eliminar'
                        position='top center'
                        inverted
                      />
                    </span>
                  }
                  header={`¿Desea eliminar la parte ${element.partCode}?`}
                  actions={[
                    {'key': 'cancel', 'content': 'Cancelar'},
                    {
                      'key': 'done',
                      'content': 'Confirmar',
                      'positive': true,
                      'onClick': () => this.onDeleteClick(index, element),
                      'primary': true,
                    },
                  ]}
                />
              )}
            </Table.Cell>
          )}
        </Table.Row>
      );
    });
  }

  renderData(fields) {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems(fields);
  }

  render() {
    const {loading, fields} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active />
          </Table.Cell>
        </Table.Row>
      );
    }

    return this.renderItems(fields);
  }
}

const mapStateToProps = (state) => {
  return {
    'orderStatus': state.form.qualityAssuranceOrders.values.status,
    'loading': state.form.qualityAssuranceOrders.loading,
    'savingItem': state.form.qualityAssuranceOrders.savingItem,
    'loadingParts': state.partsAssignmentInQualityAssuranceOrders.loadingParts,
    'partsList': state.partsAssignmentInQualityAssuranceOrders.partsList,
  };
};

const {
  addPartInfo,
  updateTotals,
  addMessageBoxError,
  managePartInQualityAssuranceOrder,
} = Actions;

export default connect(mapStateToProps, {
  addPartInfo,
  updateTotals,
  addMessageBoxError,
  managePartInQualityAssuranceOrder,
})(PartsAssignmentTableItems);
